import React from 'react';
import {Dimensions, Image, Platform, StyleSheet, View} from 'react-native';
import Styles from '../../../../Styles';
import Localized from 'src/constants/AppStrings';
import AVText from 'src/components/elements/AVText';
import PointsIndicator from 'src/components/elements/rewards/PointsIndicator';
import ChevronRight from 'src/components/img/svg/ChevronRight';
import {UserRewardsTierIcon} from 'src/components/img/svg/rewards';
import {
  AnnouncementStylesDescriptor,
  CampusLocationListStylesDescriptor,
  ReferralDescriberData,
  RewardskDescriberData,
  RewardsLegacykDescriberData,
  SendSnackDescriberData,
} from 'src/components/elements/home/descriptors/campusComponents/DescriptorType';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import CoffeeIcon from 'src/components/img/svg/coffee/coffeeIcon';
import RewardCanteenHome from 'src/components/img/svg/RewardCanteenHome';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import GrpReferralRedesign from 'src/components/img/svg/GrpReferralredesign';
import NewLocationMarker from 'src/components/img/svg/NewLocationMarker';
import ShopIconNew from 'src/components/img/svg/ShopIconNew';
import GlobeMarker from 'src/components/img/svg/GlobeMarker';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const {subHeaderFontSize, bodySmallFontSize, bodyFontSize, headerFontSize} =
  getLayoutDescriber();

export function getCampusLocationStyles(): {
  [key: string]: {[key: string]: number | string};
} {
  return {
    separator: {
      backgroundColor: Styles.borderColor,
      height: 1,
    },
    recentLocationAddressText: {
      width: '100%',
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      color: Styles.lightGray,
      textAlignVertical: 'center',
      fontFamily: Styles.FontFamily.latoRegular,
    },
    locationDisplatSubText: {
      fontFamily: Styles.FontFamily.latoRegular,
    },
    recentListborder: {},
    locationListView: {
      marginVertical: Styles.Spacing.m3,
      width: '100%',
    },
    recentLocationViewLocationNameText: {
      textAlignVertical: 'center',
      width: '100%',
      color: Styles.black,
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.latoRegular,
      textTransform: 'capitalize',
    },
    locationDisplatText: {
      fontFamily: Styles.FontFamily.latoRegular,
    },
    greetNameText: {},
    descriptionText: {
      fontFamily: Styles.FontFamily.latoRegular,
    },
    balanceText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontFamily: Styles.FontFamily.latoRegular,
      fontWeight: '400',
      color: Styles.blackBase01,
      paddingBottom: Platform.OS === 'android' ? 4 : 0,
    },
  };
}
export function paymentComboIconColor() {
  return null;
}
export function rewardsViewDescriptor(
  props: RewardskDescriberData,
): JSX.Element {
  const {
    marketAccountPoints,
    onRewardsClick,
    bgSize,
    tileHeight,
    styles,
    rewardTier,
    maxPointValue,
    productThresholds,
    maxPointsLabel,
  } = props;
  return (
    <React.Fragment>
      <AVTouchableOpacity
        activeOpacity={0.75}
        accessibilityLabel={Localized.Labels.pay_earn_enjoy}
        accessibilityHint="Press to navigate to rewards"
        style={{paddingTop: 20, marginBottom: 20}}
        onPress={onRewardsClick}
        testID="qa_btn_RewardPoints"
      >
        <View
          style={[styles.container, {paddingHorizontal: Styles.Spacing.m3 + 8}]}
        >
          <View style={[styles.shadowWrapper]}>
            {Platform.OS !== 'web' && (
              <UserRewardsTierIcon
                tierName={rewardTier?.tierName}
                size={bgSize}
                style={styles.tierIcon}
              />
            )}

            <PointsIndicator
              rewardedColor={'#84BD00'}
              height={tileHeight - Styles.Spacing.m3 * 3}
              thresholds={productThresholds}
              maxPointValue={maxPointValue}
              availablePoints={marketAccountPoints}
              maxPointValueLabel={maxPointsLabel}
            />

            <View style={styles.content}>
              <AVText
                style={[
                  styles.payEarnEnjoy,
                  {fontFamily: Styles.FontFamily.latoRegular},
                ]}
              >
                {Localized.Labels.pay_earn_enjoy}
              </AVText>

              <View style={styles.rewardStatus}>
                <AVText
                  style={[
                    styles.rewardStatustxt,
                    {fontFamily: Styles.FontFamily.latoRegular},
                  ]}
                >
                  {Localized.Labels.rewards_status}
                </AVText>

                <AVText
                  style={[
                    styles.currentTierName,
                    {fontFamily: Styles.FontFamily.latoRegular},
                  ]}
                >
                  {rewardTier?.tierName}
                </AVText>
              </View>
            </View>
            <ChevronRight
              style={styles.chevron}
              color={Styles.Colors.PayNew.darkHuesBase04}
            />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function snackViewDescriptor(
  props: SendSnackDescriberData,
): JSX.Element {
  const {onSendASnackClick} = props;
  return (
    <React.Fragment>
      <View style={styles.headerView}>
        <AVText
          accessibilityRole="text"
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          accessibilityLabel={Localized.Labels.gifting_title}
          style={{
            fontWeight: '700',
            paddingLeft: Styles.Spacing.m3,
            fontSize: Styles.Fonts.f9,
            fontFamily: Styles.FontFamily.aeonikRegular,
            color: Styles.black,
          }}
          accessible={true}
          testID={'qa_Gifting_txt'}
          aria-label={`${Localized.Labels.gifting_title}, text`}
        >
          {Localized.Labels.gifting_title}
        </AVText>
      </View>
      <AVTouchableOpacity
        aria-label="onSnackGiftClick"
        accessible={true}
        accessibilityLabel="onSnackGiftClick"
        accessibilityHint="Double tap to navigate to the send a snack screen"
        accessibilityRole="button"
        role="button"
        onPress={onSendASnackClick}
        testID="qa_btn_SnackGift"
      >
        <View style={styles.container}>
          <View
            aria-label={'SnackIcon'}
            role="img"
            accessibilityRole="image"
            accessibilityLabel={'SnackIcon'}
          >
            <Image
              accessibilityLabel="Snack gift"
              accessibilityRole="image"
              role="img"
              accessible={true}
              aria-label="Snack gift"
              style={{width: 63, height: 56}}
              resizeMode="contain"
              source={require('../../../../img/companykitchenSnackGift.gif')}
            />
          </View>
          <View style={{flex: 1, margin: Styles.Spacing.m3}}>
            <AVText
              accessibilityRole="text"
              aria-label={`${Localized.Buttons.send_a_snack}, text`}
              style={{
                fontSize: Styles.Fonts.sectionHeader,
                fontWeight: '700',
                color: Styles.black,
                fontFamily: Styles.FontFamily.aeonikRegular,
              }}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityLabel={Localized.Buttons.send_a_snack}
            >
              {Localized.Labels.send_a_snack_title}
            </AVText>

            <AVText
              accessibilityLabel={
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
              aria-label={
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
              style={{
                color: Styles.black,
                fontSize: Styles.Fonts.f7,
                fontFamily: Styles.FontFamily.aeonikRegular,
                fontWeight: '400',
              }}
              accessibilityRole="text"
            >
              {
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
            </AVText>
          </View>

          <View>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function getScanAndPayTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    rowSpace: {
      marginVertical: Styles.Spacing.m2,
    },
    iconViewBackground: {
      backgroundColor: '#3A96DB29',
      width: Styles.Heights.h5,
      height: Styles.Heights.h5,
      margin: Styles.Spacing.m3,
    },
    listContainer: {
      marginTop: Styles.Spacing.m3,
    },
    titleText: {
      marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
      fontWeight: '700',
      color: Styles.black,
      fontFamily: Styles.FontFamily.latoRegular,
      fontSize: Styles.Fonts.f7,
      paddingBottom: Styles.Spacing.m2,
    },
    newTitleText: {
      width: '100%',
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.figtreeRegular,
      paddingBottom: Styles.Spacing.m2,
    },
    nameText: {
      fontWeight: '400',
      fontFamily: Styles.FontFamily.latoRegular,
      marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
      fontSize: Styles.Fonts.f7,
      color: Styles.black,
    },
    textView: {
      marginVertical: Styles.Spacing.m3,
    },
    coffeeMachineLabel: {
      color: Styles.Colors.CompanyKitchen.lightGray,
      fontWeight: '400',
      fontSize: Styles.Fonts.f0,
      fontFamily: Styles.FontFamily.figtreeRegular,
      paddingBottom: Styles.Spacing.m2,
      width: '100%',
    },
  };
}
export function infoIconInnerColor() {
  return '#009CDE';
}
export function infoIconPrimaryColor() {
  return '#3A96DB29';
}
export function announcementBtnFont(): string {
  return Styles.FontFamily.latoRegular;
}
export function announcemnentButtonColor() {
  return Styles.primaryColor;
}
export function getWidthImageAvailable() {
  return '70%';
}

export function getAnnouncementStyles(): AnnouncementStylesDescriptor {
  return StyleSheet.create({
    container: {
      alignItems: 'left',
      justifyContent: 'flex-start',
      marginTop: Styles.Spacing.m3 - 4,
      marginHorizontal: Styles.Spacing.m3,
      backgroundColor: Styles.white,
      marginBottom: Styles.Spacing.m2 + 4,
      borderRadius: Styles.Spacing.m2,
      ...getLayoutDescriber().shadowStyles().shadow,
    },
    titleText: {
      fontSize: Styles.Fonts.headerFont,
      width: '80%',
      fontWeight: '700',
      color: Styles.black,
      marginRight: Styles.Spacing.m3,
      marginLeft: Styles.Spacing.m3,
      textAlign: 'left',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    descriptionText: {
      fontSize: Styles.Fonts.sectionHeader,
      color: Styles.darkColor,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.latoRegular,
    },
  });
}
export function rewardsLegacyViewDescriptor(
  props: RewardsLegacykDescriberData,
): JSX.Element {
  const {onRewardsClick, styles, stat, isOfferAvailable} = props;
  return (
    <React.Fragment>
      <AVTouchableOpacity
        aria-label={[Localized.Labels.rewards, stat].join('. ')}
        accessible={true}
        accessibilityLabel={[Localized.Labels.rewards, stat].join('. ')}
        accessibilityHint="Double tap to navigate to the rewards screen"
        accessibilityRole="button"
        role="button"
        onPress={onRewardsClick}
        style={{marginTop: Styles.Spacing.m3}}
      >
        <View style={styles.container}>
          <View style={styles.starIconView}>
            <View accessibilityLabel={'RewardsIcon'}>
              <RewardCanteenHome />
            </View>
            <View
              style={{
                flex: 1,
                margin: Styles.Spacing.m3,
                marginRight: Styles.Spacing.m2,
              }}
            >
              <AVText
                accessibilityRole="text"
                style={{
                  color: Styles.black,
                  fontFamily: Styles.FontFamily.latoRegular,
                  fontSize: Styles.Fonts.f7,
                  marginBottom: Styles.Spacing.m1,
                  fontWeight: '700',
                }}
                accessibilityLabel={Localized.Labels.rewards}
                aria-label={`${Localized.Labels.rewards}, text`}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              >
                {Localized.Labels.rewards}
              </AVText>
              <AVText
                accessibilityRole="text"
                aria-label={`${Localized.Labels.rewards} ${stat}`}
                accessibilityLabel={`${Localized.Labels.rewards} ${stat}`}
                style={{
                  fontFamily: Styles.FontFamily.latoRegular,
                  fontWeight: '700',
                  color: Styles.black,
                  fontSize: Styles.Fonts.f7,
                }}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              >
                {stat}
              </AVText>
              {isOfferAvailable && (
                <AVText
                  accessibilityRole="text"
                  aria-label={Localized.Labels.offerAvailable}
                  accessibilityLabel={Localized.Labels.offerAvailable}
                  style={[
                    {
                      fontFamily: Styles.FontFamily.latoRegular,
                      fontWeight: '400',
                      color: Styles.black,
                      fontSize: Styles.Fonts.f1,
                    },
                  ]}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
                >
                  {Localized.Labels.offerAvailable}
                </AVText>
              )}
            </View>
          </View>

          <View style={{justifyContent: 'center'}}>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function getCampusLocationListStyles(): CampusLocationListStylesDescriptor {
  return StyleSheet.create({
    container: {
      marginTop: Styles.Spacing.m3,
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      marginBottom: Styles.Spacing.m3,
    },
    campusLocationListView: {
      width: '100%',
    },
    headerMargin: {
      marginLeft: Styles.Spacing.m3,
      marginTop: -(Styles.Spacing.m3 + Styles.Spacing.m2),
    },
    diningLocationLabel: {
      color: Styles.Colors.PayNew.black01,
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontSize: Styles.Fonts.f7,
      fontWeight: '700',
      flexWrap: 'wrap',
      width: '80%',
    },
  });
}
export function referralViewDescriptor(
  props: ReferralDescriberData,
  amtLocalised?: string,
): JSX.Element {
  const {onInviteClick, styles, stat, isSnackEnabled} = props;
  const desc = Localized.Labels.formatString(
    Localized.Labels.receive_redesign_cash_to_spend,
    amtLocalised,
  );
  const title = Localized.Labels.formatString(
    Localized.Labels.give_get_redesign,
    amtLocalised,
    amtLocalised,
  );
  return (
    <React.Fragment>
      {!isSnackEnabled && (
        <View style={styles.headerView}>
          <AVText
            accessibilityRole="text"
            style={{
              fontWeight: '700',
              fontSize: Styles.Fonts.f9,
              fontFamily: Styles.FontFamily.latoRegular,
              color: Styles.black,
            }}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessible={true}
            aria-label={`${Localized.Labels.recents}, text`}
            accessibilityLabel={Localized.Labels.recents}
          >
            {Localized.Labels.gifting_title}
          </AVText>
        </View>
      )}
      <AVTouchableOpacity
        accessible={true}
        onPress={onInviteClick}
        accessibilityLabel={[title, desc, stat].join('. ')}
        accessibilityHint="Double tap to navigate to the Refferals screen"
        role="button"
        aria-label={[title, desc, stat].join('. ')}
        accessibilityRole="button"
        testID="qa_btn_Refferals"
      >
        <View style={styles.container} nativeID="qa_btn_Refferals">
          <View
            role="img"
            accessibilityLabel={'grpreferralIcon'}
            accessibilityRole="image"
            aria-label={'grpreferralIcon'}
          >
            <GrpReferralRedesign
              width={63}
              height={56}
              gradColor1={Styles.Colors.CompanyKitchen.green}
              gradColor2={Styles.Colors.CompanyKitchen.primary}
            />
          </View>
          <View style={{flex: 1, margin: Styles.Spacing.m3}}>
            <AVText
              aria-label={`${title}, text`}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityRole="text"
              style={{
                fontWeight: '700',
                paddingVertical: Styles.Spacing.m2,
                fontSize: Styles.Fonts.sectionHeader,
                fontFamily: Styles.FontFamily.latoRegular,
                color: Styles.black,
              }}
              accessibilityLabel={title as string}
            >
              {title}
            </AVText>

            <AVText
              accessibilityLabel={desc as string}
              aria-label={desc as string}
              accessibilityRole="text"
              style={{
                fontWeight: '400',
                fontSize: Styles.Fonts.f7,
                color: Styles.black,
                fontFamily: Styles.FontFamily.latoRegular,
              }}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            >
              {desc}
            </AVText>
            <AVText
              accessibilityRole="text"
              accessibilityLabel={Localized.Labels.receive_cash_to_spend}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
              aria-label={Localized.Labels.receive_cash_to_spend}
              style={[
                styles.snackDescriptionText,
                {
                  fontFamily: Styles.FontFamily.latoRegular,
                  fontSize: Styles.Fonts.f7,
                  fontWeight: '400',
                  color: '#727179',
                },
              ]}
            >
              {stat}
            </AVText>
          </View>

          <View>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}

export function getEngagementCarouselPaginationActiveDotColor(): string {
  return '#066DFF';
}

export function RecentlocationListIcon(): JSX.Element {
  return <ShopIconNew size={Styles.Spacing.m4} />;
}
export function locationListIcon(): JSX.Element {
  return <ShopIconNew size={24} />;
}
export function getScanAndPayTileIcon(coffeMachineType: boolean): JSX.Element {
  if (coffeMachineType) {
    return <CoffeeIcon width={26} height={26} color={Styles.secondaryColor} />;
  } else {
    return (
      <Image
        source={require('src/components/img/scanIconCK.png')}
        style={{
          height: Styles.Heights.h5 / 2,
          width: Styles.Heights.h5 / 2,
        }}
      />
    );
  }
}

export function getVendingTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    headerText: {
      color: Styles.black,
      fontSize: Styles.Fonts.headerFont,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.latoRegular,
      marginTop: 16,
      marginLeft: Styles.Spacing.m2,
    },
    vendingSmatxt: {
      color: Styles.black,
      fontSize: Styles.Fonts.f9 - 6,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.latoRegular,
      fontStyle: 'italic',
      marginTop: 16,
      paddingHorizontal: 24,
    },
    nameText: {
      width: '100%',
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.latoRegular,
    },
    buttonText: {
      color: Styles.primaryColor,
      backgroundColor: 'transparent',
      fontSize: Styles.Fonts.f1,
      fontWeight: '600',
      fontStyle: 'normal',
      fontFamily: Styles.FontFamily.latoRegular,
    },
  };
}

export function getDiningTile(): {
  [key: string]: {[index: string]: number | string};
} {
  const windowWidth = Dimensions.get('window').width;
  return {
    nameText: {
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: Styles.Fonts.sectionHeader,
      marginTop: Styles.Spacing.m2,
      paddingLeft: Styles.Spacing.m1,
      fontFamily: Styles.FontFamily.latoRegular,
      width: windowWidth - Styles.Spacing.m4 - Styles.Spacing.m3,
    },
  };
}

export function getQRCodeTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    quickFundText: {
      fontFamily: Styles.FontFamily.latoRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.f1,
    },
    balanceText: {
      color: Styles.darkColor,
      fontWeight: '400',
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.latoRegular,
    },
    balanceValue: {
      fontSize: Styles.Fonts.f2,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.latoRegular,
    },
  };
}

export function getScanAndPayMismatchLocationError(): JSX.Element {
  return (
    <View style={styles.locationErrorContainer}>
      <AVText
        accessibilityRole="text"
        accessibilityElementsHidden={true}
        style={styles.locationDescription}
        aria-label={`${Localized.Labels.your_account_balance_is_not_valid_at_some_locations}, text`}
        accessibilityLabel={
          Localized.Labels.your_account_balance_is_not_valid_at_some_locations
        }
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
      >
        {'*' +
          Localized.Labels.your_account_balance_is_not_valid_at_some_locations}
      </AVText>
    </View>
  );
}

export function getTileButton(
  buttonText: string,
  handleClick: () => void,
  outline?: boolean,
  height?: number,
): JSX.Element {
  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        paddingVertical: Styles.Spacing.m2,
      }}
    >
      <RoundedAppButton
        buttonViewStyle={{
          width: '100%',
          height: height ? height : Styles.Heights.touchTargetHeight1,
        }}
        buttonContainerStyle={{
          width: '100%',
        }}
        textStyle={[
          {
            fontSize: Styles.Fonts.f8,
            fontWeight: '700',
          },
        ]}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        buttonType={
          outline ? RoundedAppButtonType.Outline : RoundedAppButtonType.Solid
        }
        titleText={buttonText}
        accessibilityLabelValue={buttonText}
        aria-label={buttonText}
        onPress={handleClick}
      />
    </View>
  );
}

function getLocationMarkerErrorIcon(locationEnabled: boolean) {
  return locationEnabled ? (
    <NewLocationMarker
      primaryFill={Styles.Colors.CompanyKitchen.primary}
      secondaryFill={Styles.Colors.Canteen.lightGray}
    />
  ) : (
    <GlobeMarker primaryFill={Styles.Colors.CompanyKitchen.primary} />
  );
}

export function getNoNearbyLocationsComponent(
  locationEnabled: boolean,
): JSX.Element {
  return (
    <View
      style={{
        marginTop: Styles.Spacing.m3 + Styles.Spacing.m1,
        marginBottom: Styles.Spacing.m3 + Styles.Spacing.m1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          width: Styles.Heights.h5,
          height: Styles.Heights.h5,
          marginBottom: Styles.Spacing.m2,
          marginTop: Styles.Spacing.m4,
        }}
      >
        {getLocationMarkerErrorIcon(locationEnabled)}
      </View>
      <AVText
        style={{
          fontSize: Styles.Fonts.sectionHeader,
          fontWeight: '800',
          fontFamily: Styles.FontFamily.latoRegular,
          color: Styles.Colors.PayNew.black01,
          marginTop: Styles.Spacing.m4 + Styles.Spacing.m2,
          marginBottom: Styles.Spacing.m3,
          textAlign: 'center',
        }}
      >
        {locationEnabled
          ? Localized.Labels.there_are_no_locations_near_you
          : Localized.Labels
              .turn_location_services_on_to_access_nearby_locations}
      </AVText>
    </View>
  );
}

const styles = StyleSheet.create({
  locationErrorContainer: {
    marginHorizontal: Styles.Spacing.m0,
    marginVertical: Styles.Spacing.m1,
  },
  locationHeader: {
    fontWeight: '700',
    color: Styles.black,
    fontFamily: Styles.FontFamily.latoRegular,
    fontSize: Styles.Fonts.headerFont,
    textTransform: 'capitalize',
  },
  locationDescription: {
    fontFamily: Styles.FontFamily.latoRegular,
    marginTop: Styles.Spacing.m2,
    marginLeft: -Styles.Spacing.m1,
    fontStyle: 'italic',
    color: Styles.black,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    textAlign: 'left',
  },
  container: {
    flexDirection: 'row',
    backgroundColor: Styles.white,
    margin: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m2,
    justifyContent: 'center',
    alignItems: 'center',
    ...getLayoutDescriber().shadowStyles().shadow,
    minHeight: Styles.MinTouchableArea,
  },
  headerView: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
});

export default {
  getAnnouncementStyles,
  getCampusLocationStyles,
  snackViewDescriptor,
  infoIconPrimaryColor,
  infoIconInnerColor,
  getCampusLocationListStyles,
  rewardsViewDescriptor,
  announcementBtnFont,
  RecentlocationListIcon,
  getScanAndPayTile,
  announcemnentButtonColor,
  locationListIcon,
  getScanAndPayTileIcon,
  referralViewDescriptor,
  rewardsLegacyViewDescriptor,
  getEngagementCarouselPaginationActiveDotColor,
  getWidthImageAvailable,
  getVendingTile,
  getDiningTile,
  getQRCodeTile,
  getScanAndPayMismatchLocationError,
  getTileButton,
  getNoNearbyLocationsComponent,
  paymentComboIconColor,
};
